import { useCallback, useEffect, useRef, useState } from 'react'
import { revokeSentGalleryItems } from './revokeSentGalleryItems'

export function useUserChatBubbleGallery(imageAttachmentsOnly) {
  const [sentGalleryOpen, setSentGalleryOpen] = useState(false)
  const [sentGallerySession, setSentGallerySession] = useState(0)
  const [sentGalleryInitialIndex, setSentGalleryInitialIndex] = useState(0)
  const [sentGalleryItems, setSentGalleryItems] = useState([])
  const sentGalleryItemsUnmountRef = useRef([])

  useEffect(() => {
    sentGalleryItemsUnmountRef.current = sentGalleryItems
  }, [sentGalleryItems])

  useEffect(() => () => revokeSentGalleryItems(sentGalleryItemsUnmountRef.current), [])

  const closeSentImageGallery = useCallback(() => {
    setSentGalleryItems((items) => {
      revokeSentGalleryItems(items)
      return []
    })
    setSentGalleryOpen(false)
  }, [])

  const openSentImageGallery = useCallback(
    (imageIndex) => {
      if (imageAttachmentsOnly.length === 0) return
      setSentGalleryItems((prev) => {
        revokeSentGalleryItems(prev)
        return imageAttachmentsOnly.map((file, i) => ({
          id: `sent-img-${i}-${file.name}-${file.size}`,
          file,
          previewUrl: URL.createObjectURL(file),
        }))
      })
      setSentGalleryInitialIndex(imageIndex)
      setSentGallerySession((s) => s + 1)
      setSentGalleryOpen(true)
    },
    [imageAttachmentsOnly],
  )

  return {
    sentGalleryOpen,
    sentGallerySession,
    sentGalleryInitialIndex,
    sentGalleryItems,
    closeSentImageGallery,
    openSentImageGallery,
  }
}
